import { all, takeLatest, put, fork, call } from "redux-saga/effects";
import { REQUEST_LANG } from "../constants/Lookup";
import { receiveLangData } from "../actions/Lookup";
import _ from "lodash";
import Services from "../../services/ApiService";
export function* getLanguages() {
  yield takeLatest(REQUEST_LANG, function* () {
    try {
      const response = yield call(Services.fetchData, "/api/Language");
      if (response.state) {
        const sortedData = _.sortBy(response.data, [
          function (o) {
            return o.locale;
          },
        ]);
        yield put(receiveLangData(sortedData));
      } else {
        yield put();
      }
    } catch (err) {
    }
  });
}
export default function* rootSaga() {
  yield all([fork(getLanguages)]);
}
